import { Component, OnInit } from "@angular/core";
import { HastalistesiService } from "../services/hastalistesi.service";
import { RandevuHastaListesi } from "./randevu-hasta-listesi";
import { Router } from "@angular/router";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogBoxComponent } from "../dialog-box/dialog-box.component";
import { JwtHelperService } from "@auth0/angular-jwt";

@Component({
  selector: "app-randevulistesi",
  templateUrl: "./randevulistesi.component.html",
  styleUrls: ["./randevulistesi.component.css"],
})
export class RandevulistesiComponent implements OnInit {
  hastaReferans: string;
  hastaAdisoyadi: string;
  rndHListesi: RandevuHastaListesi[];

  decodeToken: any;
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private hastalistesi: HastalistesiService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    if (!this.jwtHelper.isTokenExpired(localStorage.getItem("TurcaSoft"))) {
      this.decodeToken = this.jwtHelper.decodeToken(
        localStorage.getItem("TurcaSoft")
      );
      this.hastaReferans = this.decodeToken["_hRef"];
      this.hastaAdisoyadi = this.decodeToken["_hAdi"];
      this.getHRandevuList();
    }
  }

  getHRandevuList() {
    this.hastalistesi
      .getHastaRndListesi(Number(this.hastaReferans))
      .subscribe((response) => {
        this.rndHListesi = response;
      });
  }

  randevuIptalOnay(rHListesi) {
    this.hastalistesi.randevuSil(rHListesi).subscribe((response) => {
      if (response["sonucKodu"] == 0) {
        const index = this.rndHListesi.indexOf(rHListesi);
        this.rndHListesi.splice(index, 1);
      }

      this.openDialog(
        "Randevu İpal Sonuç",
        "Randevu iptal işleminiz başarı ile sona erdi.",
        null,
        "Tamam",
        null
      );
    });
  }

  randevuIptal(rHListesi) {
    this.openDialog(
      "Randevu İpal",
      "Lütfen dikkat. Seçili randevu kaydını iptal ediyorsunuz emin misiniz?",
      "Evet",
      "Hayır",
      rHListesi
    );
  }

  geriDon() {
    this.router.navigateByUrl("randevu-ver");
  }

  openDialog(
    _baslik: string,
    _mesaj: string,
    _bntOk: string,
    _btnIptal: string,
    _data: any
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";

    let dialogRef = this.dialog.open(DialogBoxComponent, {
      disableClose: true,
      autoFocus: true,
      width: "45%",

      data: {
        baslik: _baslik,
        mesaj: _mesaj,
        bntOk: _bntOk,
        btnIptal: _btnIptal,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});

    const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(
      (result) => {
        ///  dialogSubmitSubscription.unsubscribe();
        this.randevuIptalOnay(_data);
      }
    );
  }


}
